import * as React from 'react';
import { Spinner, Intent, Callout } from '@blueprintjs/core';
import { executeQueryPost } from 'app/utils/api';
import { StandardInput } from '../StandardInput';
import { LargeButton } from '../LargeButton';

const CONFIRMATION_MESSAGE = 'A password reset email has been sent to your email address.  Please check your inbox and spam folder.';

interface Props {
    
};

interface State {
    waitingForAPI: boolean;
    userEmail: string;
    showConfirmation: boolean;
}

export class ForgotPassword extends React.Component<Props, State> {

    state: State = {
        waitingForAPI: false,
        userEmail: "",
        showConfirmation: false
    }
    
    handleSendRequest = () => {
        const {
            userEmail
        } = this.state;

        this.setState({
            waitingForAPI: true
        });

        executeQueryPost("users/forgotpassword", {
            email: userEmail
        }, (response) => {
            this.setState({
                showConfirmation: true,
                waitingForAPI: false
            });
        })
    }

    handleEmailChange = (e:any) => {
		if (e && e.target) {
			const newValue = e.target.value;

			this.setState({
				userEmail: newValue
			});
		}
	}

	render() {
        const {
            waitingForAPI,
            showConfirmation,
            userEmail
        } = this.state;

        if (waitingForAPI) return <Spinner />

        if (showConfirmation) return <span>
            <Callout intent={Intent.PRIMARY} icon={"info-sign"}>
                {CONFIRMATION_MESSAGE}
            </Callout>
        </span>
        
		return <span>
            <StandardInput 
                autoFocus={true}
                onChange={this.handleEmailChange}
                type={"email"}
                value={userEmail}
                label={"Your Account's Email Address"} />

            <LargeButton text={"Reset Password"} rightIcon={"envelope"} intent={Intent.SUCCESS} onClick={() => {
                this.handleSendRequest();
            }} />
        </span>
	}
}
